"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_typed_1 = require("schema-typed");
var lodash_upperfirst_1 = __importDefault(require("lodash.upperfirst"));
var MessageFormatter_1 = __importDefault(require("../MessageFormatter"));
var Types = {
    ArrayType: schema_typed_1.ArrayType,
    BooleanType: schema_typed_1.BooleanType,
    DateType: schema_typed_1.DateType,
    NumberType: schema_typed_1.NumberType,
    ObjectType: schema_typed_1.ObjectType,
    StringType: schema_typed_1.StringType,
};
var BaseTypeAdaptor = /** @class */ (function () {
    function BaseTypeAdaptor(fieldName, validator) {
        this.$fieldName = fieldName;
        this.$messageFormatter = new MessageFormatter_1.default(validator).setAdaptor(this);
    }
    BaseTypeAdaptor.prototype.getFieldName = function () {
        return this.$fieldName;
    };
    BaseTypeAdaptor.prototype.getType = function () {
        return this.$type;
    };
    BaseTypeAdaptor.prototype.setArrayAdaptor = function (adaptor) {
        this.$arrayAdaptor = adaptor;
    };
    BaseTypeAdaptor.prototype.getArrayAdaptor = function () {
        return this.$arrayAdaptor;
    };
    BaseTypeAdaptor.prototype.getSchemaType = function () {
        if (!this.$schemaType) {
            this.$schemaType = this.makeSchemaType();
        }
        return this.$schemaType;
    };
    BaseTypeAdaptor.prototype.makeSchemaType = function () {
        var _a;
        return (_a = this.guessSchemaTypeConstructor()) === null || _a === void 0 ? void 0 : _a(this.getErrorMessage(this.$type));
    };
    BaseTypeAdaptor.prototype.guessSchemaTypeConstructor = function () {
        var _a;
        return ((_a = this.$schemaTypeConstructor) !== null && _a !== void 0 ? _a : Types[(0, lodash_upperfirst_1.default)(this.$type) + "Type"]);
    };
    BaseTypeAdaptor.prototype.applyRule = function (rule) {
        var _this = this;
        if (typeof rule === "string") {
            var _a = rule.split(":", 2), slug = _a[0], args = _a[1];
            var method = this[slug];
            if (typeof method !== "function") {
                this.ignoreRule(rule, "no such rule as '" + slug + "' is found on type '" + this.$type + "'");
            }
            else {
                method.apply(this, (args !== null && args !== void 0 ? args : "").split(","));
            }
        }
        else if (this.isCustomRule(rule)) {
            this.getSchemaType().addRule(function (value, data) { return rule.check(_this.getFieldName(), value, data); }, this.$messageFormatter.formatMessage(rule.errorMessage));
        }
    };
    BaseTypeAdaptor.prototype.isCustomRule = function (rule) {
        return (!!rule && typeof rule === "object" && typeof rule.check === "function");
    };
    BaseTypeAdaptor.prototype.ignoreRule = function (rule, reason) {
        console.warn(new Error("Validation '" + rule + "' for field '" + this.getFieldName() + "' is ignored because " + reason + "."));
    };
    BaseTypeAdaptor.prototype.getErrorMessage = function (rule, placeholderValues) {
        var _a;
        return ((_a = this.$messageFormatter.getFormattedMessage(rule, placeholderValues)) !== null && _a !== void 0 ? _a : "");
    };
    BaseTypeAdaptor.prototype.applyRules = function (rules) {
        var _this = this;
        rules.forEach(function (rule) {
            _this.applyRule(rule);
        });
        return this;
    };
    /**
     * Common rules implementations
     */
    BaseTypeAdaptor.prototype.required = function () {
        this.getSchemaType().isRequired(this.getErrorMessage("required"));
        return this;
    };
    BaseTypeAdaptor.prototype.size = function (value) {
        var _this = this;
        this.getSchemaType().addRule(function (v) {
            return _this.getSize(v) === +value;
        }, this.getErrorMessage("size", { value: value }));
        return this;
    };
    BaseTypeAdaptor.prototype.min = function (value) {
        var _this = this;
        this.getSchemaType().addRule(function (v) {
            return _this.getSize(v) >= +value;
        }, this.getErrorMessage("min", { value: value }));
        return this;
    };
    BaseTypeAdaptor.prototype.max = function (value) {
        var _this = this;
        this.getSchemaType().addRule(function (v) {
            return _this.getSize(v) <= +value;
        }, this.getErrorMessage("max", { value: value }));
        return this;
    };
    BaseTypeAdaptor.prototype.between = function (min, max) {
        var _this = this;
        this.getSchemaType().addRule(function (v) {
            var size = _this.getSize(v);
            return size >= +min && size <= +max;
        }, this.getErrorMessage("between", { min: min, max: max }));
        return this;
    };
    BaseTypeAdaptor.prototype.gt = function (field) {
        var _this = this;
        this.getSchemaType().addRule(function (value, data) {
            var otherSize = _this.getSize(data[field]);
            return {
                hasError: !(_this.getSize(value) > otherSize),
                errorMessage: _this.getErrorMessage("gt", {
                    other: field,
                    value: otherSize,
                }),
            };
        }, "");
        return this;
    };
    BaseTypeAdaptor.prototype.gte = function (field) {
        var _this = this;
        this.getSchemaType().addRule(function (value, data) {
            var otherSize = _this.getSize(data[field]);
            return {
                hasError: !(_this.getSize(value) >= otherSize),
                errorMessage: _this.getErrorMessage("gte", {
                    other: field,
                    value: otherSize,
                }),
            };
        }, "");
        return this;
    };
    BaseTypeAdaptor.prototype.lt = function (field) {
        var _this = this;
        this.getSchemaType().addRule(function (value, data) {
            var otherSize = _this.getSize(data[field]);
            return {
                hasError: !(_this.getSize(value) < otherSize),
                errorMessage: _this.getErrorMessage("lt", {
                    other: field,
                    value: otherSize,
                }),
            };
        }, "");
        return this;
    };
    BaseTypeAdaptor.prototype.lte = function (field) {
        var _this = this;
        this.getSchemaType().addRule(function (value, data) {
            var otherSize = _this.getSize(data[field]);
            return {
                hasError: !(_this.getSize(value) <= otherSize),
                errorMessage: _this.getErrorMessage("lte", {
                    other: field,
                    value: otherSize,
                }),
            };
        }, "");
        return this;
    };
    BaseTypeAdaptor.prototype.same = function (field) {
        this.getSchemaType().addRule(function (value, data) {
            return value === data[field];
        }, this.getErrorMessage("same", { other: field }));
        return this;
    };
    BaseTypeAdaptor.prototype.different = function (field) {
        this.getSchemaType().addRule(function (value, data) {
            return value !== data[field];
        }, this.getErrorMessage("same", { other: field }));
        return this;
    };
    BaseTypeAdaptor.prototype.in = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        this.getSchemaType().addRule(function (value) {
            return values.includes(value);
        }, this.getErrorMessage("in", { values: values }));
        return this;
    };
    BaseTypeAdaptor.prototype.notIn = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        this.getSchemaType().addRule(function (value) {
            return !values.includes(value);
        }, this.getErrorMessage("notIn", { values: values }));
        return this;
    };
    return BaseTypeAdaptor;
}());
exports.default = BaseTypeAdaptor;
